// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_4YE","cls2":"common-cls2_4Fa common-cls1_4YE"};